import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'lodash/noop';

import { SuiField } from '@splashthat/sui';

import './styles.styl';

import BorderPickerDropdownOption from './BorderPickerDropdownOption';
import BorderPickerDropdownPopover from './BorderPickerDropdownPopover';

import ChevronDown from '../../../icons/ChevronDown';

const widthOptions = [1, 2, 3, 4, 5];
const BASE_CLASS_NAME = 'BorderPickerDropdown';

class BorderPickerDropdown extends Component {
    static propTypes = {
        defaultBorderWidth: PropTypes.number,
        getAnchorEl: PropTypes.func,
        getRefWidth: PropTypes.func,
        onBorderWidthsChanged: PropTypes.func,
        qaId: PropTypes.string.isRequired,
        'aria-label': PropTypes.string,
    };

    static defaultProps = {
        defaultBorderWidth: 1,
        getAnchorEl: noop,
        getRefWidth: noop,
        onBorderWidthsChanged: noop,
        'aria-label': undefined,
    };

    state = {
        popoverIsVisible: false,
    };

    onClickShowPopover = (e) => {
        e && e.stopPropagation();
        this.setState({
            popoverIsVisible: !this.state.popoverIsVisible,
        });
    };

    showBorderPickerPopover = () => (
        <BorderPickerDropdownPopover
            showPopover={this.state.popoverIsVisible}
            onClickClose={this.onClickShowPopover}
            anchorEl={this.props.getAnchorEl()}
            widthOptions={widthOptions}
            minWidth={this.props.getRefWidth()}
            onBorderWidthsChanged={this.props.onBorderWidthsChanged}
            defaultBorderWidth={this.props.defaultBorderWidth}
            qaId={`${this.props.qaId}--popover`}
        />
    );

    render() {
        const { defaultBorderWidth, qaId, 'aria-label': ariaLabel } = this.props;
        const { popoverIsVisible } = this.state;

        return (
            <React.Fragment>
                <SuiField
                    className={`${BASE_CLASS_NAME}__selector`}
                    formElement={
                        <button
                            onClick={this.onClickShowPopover}
                            className={`${BASE_CLASS_NAME}__selector`}
                            data-qa={`${qaId}--dropdown`}
                            aria-label={ariaLabel}
                        >
                            <BorderPickerDropdownOption height={defaultBorderWidth} />
                            <div className={`${BASE_CLASS_NAME}__icon`}>
                                <ChevronDown />
                            </div>
                        </button>
                    }
                />
                {popoverIsVisible ? this.showBorderPickerPopover() : null}
            </React.Fragment>
        );
    }
}

export default BorderPickerDropdown;
